import { LockOutlined } from "@ant-design/icons";
import { Button, Input, message } from "antd";
import React, { useState } from "react";
import useAxios from "../../hooks/useAxios";
import { useHistory } from "react-router-dom";

const ConfirmPassword = ({ loginType, value, otp }) => {
  const api = useAxios();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState({});
  const [loading, setLoading] = useState(false);
  const history = useHistory();

  const checkValidation = () => {
    let e = {};
    const confValue = confirmPassword.trim();
    const newValue = password.trim();

    if (!confValue) {
      e.confirmPassword = "Confirm Password is required.";
    }

    if (!newValue) {
      e.password = "Password is required.";
    }

    if (confValue !== newValue) {
      e.confirmPassword = "Passwords do not match.";
    }

    setError(e);

    return Object.keys(e).length === 0;
  };

  const onCLickSavePassword = async (e) => {
    try {
      e.preventDefault();
      const isProceed = checkValidation();

      if (!isProceed) return;

      setLoading(true);

      const result = await api.post(`/candidate/updatePassword`, {
        ...(loginType === "email" ? { email: value } : { phone: value }),
        OTP: otp,
        newPassword: password,
        confirmNewPassword: confirmPassword,
      });

      if (result.status === 200) {
        localStorage.clear();
        message.success(result.data.message);
        history.push("/careers");
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const inputStyles = {
    padding: "10px 11px",
    fontSize: "16px",
    lineHeight: 1.5,
    borderRadius: "8px",
  };

  const btnStyle = {
    height: 48,
    borderRadius: 10,
    fontWeight: 500,
    fontSize: 16,
    background:
      "linear-gradient(41deg, rgb(241,120,35) 0%, rgb(248,166,27) 100%)",
    border: "none",
  };

  return (
    <form className="user">
      <div className="mb-[24px]">
        <Input.Password
          style={inputStyles}
          name="password"
          onChange={(e) => setPassword(e.target.value)}
          value={password}
          size="large"
          prefix={
            <span className="pr-1">
              <LockOutlined />
            </span>
          }
          placeholder={"New Password"}
          status={error?.password && error?.password ? "error" : ""}
        />
        {error?.password && (
          <div className="text-[#ff4d4f]">{error?.password}</div>
        )}
      </div>
      <div className="mb-[24px]">
        <Input.Password
          style={inputStyles}
          name="confirmPassword"
          onChange={(e) => setConfirmPassword(e.target.value)}
          value={confirmPassword}
          size="large"
          prefix={
            <span className="pr-1">
              <LockOutlined />
            </span>
          }
          placeholder={"Confirm Password"}
          status={
            error?.confirmPassword && error?.confirmPassword ? "error" : ""
          }
        />
        {error?.confirmPassword && (
          <div className="text-[#ff4d4f]">{error?.confirmPassword}</div>
        )}
      </div>
      <div>
        <Button
          htmlType="submit"
          loading={loading}
          onClick={onCLickSavePassword}
          className="w-100 mt-4"
          type="primary"
          value="large"
          iconPlacement="end"
          style={btnStyle}
        >
          Save Password
        </Button>
      </div>
    </form>
  );
};

export default ConfirmPassword;
